import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { plainToClass } from 'class-transformer';

import { environment } from '../../../environments/environment';
import { ProgressIndicatorService } from './progress-indicator.service';
import { CollectApiServiceBase } from './collect-api-base.service';
import { ScheduledEvent } from '../models/scheduled-events/scheduled-event.model';
import { ScheduledDataCollectionEvent } from '../models/scheduled-events/scheduled-data-collection-event.model';
//import { ScheduledFolderEvent } from '../models/scheduled-events/scheduled-folder-event.model';
import { ScheduledEventObjectType, ScheduledAction } from '../models/scheduled-events/scheduled-event.enums';

export class DummyScheduledEvent extends ScheduledEvent {
    // Constructor.
    public constructor() {
        super();

        //this.action = ScheduledAction.Dummy;
    }

    // Abstract method(s).
    public objectType(): ScheduledEventObjectType {
        return ScheduledEventObjectType.Dummy;
    }
}

@Injectable()
export class ScheduledEventService extends CollectApiServiceBase<ScheduledEvent> {
    // Constructor.
    public constructor(http: HttpClient, progressIndicatorService: ProgressIndicatorService) {
        //super(http, progressIndicatorService, environment.apiUrl, 'scheduledEvent', ScheduledEvent);
        super(http, progressIndicatorService, environment.apiUrl, 'scheduledEvent', DummyScheduledEvent);
    }

    // Overrides.
    public querySystemEvents(dataCollectionId = 0, eventType: string = null): Promise<ScheduledEvent[]> {
        let url =
            (eventType != null ?
                `${this.url}/${this.endpoint}/querySystemEvents/${dataCollectionId}/ofType/${eventType}` :
                `${this.url}/${this.endpoint}/querySystemEvents/${dataCollectionId}`);

        return this.http.get<ScheduledEvent[]>(url)
            .toPromise()
            .then(response => {
                let events: ScheduledEvent[] = this.packageScheduledEvents(response);

                //this.updateProgress(100, 100, `Completed`);

                return (events);
            })
            .catch(this.handleError);
    }

    public queryUpcomingSiteEvents(dataCollectionId: number, eventType: string): Promise<ScheduledEvent[]> {
        let url =
            (eventType != null ?
                `${this.url}/${this.endpoint}/queryUpcomingSiteEvents/${dataCollectionId}/ofType/{eventType}` :
                `${this.url}/${this.endpoint}/queryUpcomingSiteEvents/${dataCollectionId}`);

        //this.updateProgress(50, 75, `Querying scheduled events ...`);

        return this.http.get<ScheduledEvent[]>(url)
            .toPromise()
            .then(response => {
                /*
                let events: ScheduledEvent[] = [];

                if (response != null) {
                    for (let iEvent: number = 0; iEvent < response.length; iEvent++) {
                        let oEvent: ScheduledEvent = response[iEvent];
                        // Note:  cannot directly instantiate an instance of abstract class ScheduledEvent.
                        let event: ScheduledEvent = plainToClass(DummyScheduledEvent, oEvent);

                        events.push(event);
                    }
                }
                */
                let events: ScheduledEvent[] = this.packageScheduledEvents(response);

                //this.updateProgress(100, 100, `Completed`);

                return (events);
            })
            .catch(this.handleError);
    }

    // Private helper methods.
    private packageScheduledEvents(response: ScheduledEvent[]): ScheduledEvent[] {
        let events: ScheduledEvent[] = [];

        if (response != null) {
            for (let iEvent: number = 0; iEvent < response.length; iEvent++) {
                let oEvent: ScheduledEvent = response[iEvent];
                // Note:  cannot directly instantiate an instance of abstract class ScheduledEvent.
                let event: ScheduledEvent = plainToClass(DummyScheduledEvent, oEvent);

                events.push(event);
            }
        }

        return events;
    }

    // Not presently used service methods.
    /*
    public createScheduledEvent(scheduledEvent: ScheduledEvent): Promise<ScheduledEvent> {
        //let url = `${this.url}/${this.endpoint}/create`;
        let objectType: string = scheduledEvent.objectType();
        let url: string = `${this.url}/${this.endpoint}/createScheduled${objectType}Event`;

        this.updateProgress(50, 75, `Scheduling a data collection event ...`);

        return this.http.post<ScheduledFolderEvent>(url, scheduledEvent)
            .toPromise()
            .then(response => {
                let obj: ScheduledDataCollectionEvent = plainToClass(ScheduledDataCollectionEvent, response);

                this.updateProgress(100, 100, `Scheduled the event`);

                return obj;
            })
            .catch(this.handleError);
    }
    */

    /*
    public createScheduledDataCollectionEvent(scheduledEvent: ScheduledDataCollectionEvent): Promise<ScheduledDataCollectionEvent> {
        let url = `${this.url}/${this.endpoint}/createScheduledDataCollectionEvent`;

        this.updateProgress(50, 75, `Scheduling a data collection event ...`);

        return this.http.post<ScheduledFolderEvent>(url, scheduledEvent)
            .toPromise()
            .then(response => {
                let obj: ScheduledDataCollectionEvent = plainToClass(ScheduledDataCollectionEvent, response);

                this.updateProgress(100, 100, `Scheduled the event`);

                return obj;
            })
            .catch(this.handleError);
    }

    public createScheduledFolderEvent(scheduledEvent: ScheduledFolderEvent): Promise<ScheduledFolderEvent> {
        let url = `${this.url}/${this.endpoint}/createScheduledFolderEvent`;

        this.updateProgress(50, 75, `Scheduling a folder event ...`);

        return this.http.post<ScheduledFolderEvent>(url, scheduledEvent)
            .toPromise()
            .then(response => {
                let obj: ScheduledFolderEvent = plainToClass(ScheduledFolderEvent, response);

                this.updateProgress(100, 100, `Scheduled the event`);

                return obj;
            })
            .catch(this.handleError);
    }
    */
}
